import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Paywall() {
  const [loading, setLoading] = useState(false);
  const subscribe = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/billing/checkout", { origin_url: window.location.origin });
      if (data.requires_payment) {
        window.location.href = data.checkout_url;
      } else {
        window.location.reload();
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start checkout.");
      setLoading(false);
    }
  };
  return (
    <div style={{ maxWidth: 520, margin: "80px auto", padding: "0 24px", textAlign: "center" }}>
      <div className="bg-card-gold" style={{ padding: 40 }}>
        <div style={{ fontSize: 11, letterSpacing: "0.3em", color: "var(--gold)", marginBottom: 14 }}>SUBSCRIBE</div>
        <h1 className="serif" style={{ fontSize: 36, color: "#fff", margin: "0 0 12px", fontWeight: 400 }}>Activate your account</h1>
        <p className="muted" style={{ marginBottom: 22 }}>$10 / month for unlimited AI obituaries, portraits, quotes, programs, and acknowledgements. Cancel anytime.</p>
        <button data-testid="paywall-subscribe" onClick={subscribe} disabled={loading} className="btn-gold" style={{ padding: "14px 34px" }}>
          {loading ? "Redirecting…" : "Subscribe — $10 / month"}
        </button>
      </div>
    </div>
  );
}
